module.exports = __webpack_public_path__ + "static/img/hover-4.87ebe6a4.png";